import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import Header from "layouts/profile/components/Header";
import EditProfileDialog from "layouts/profile/components/EditProfileDialog";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { useEffect, useState } from "react";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import MDSnackbar from "components/MDSnackbar";
import { setUserPhoto } from "../../Redux/action/sessionAction";
import {
  fetchEducationDetailsByParent,
  syncEducationEntries,
} from "../../services/educationService";
import { fetchWorkDetailsByParent, syncWorkEntries } from "../../services/workService";
import { fetchIDCardDetailsByParent, syncIDCardEntries } from "../../services/idCardService";
import { fetchBankDetailsByParent, syncBankDetailsEntries } from "../../services/bankDetailsService";
import { fetchSocialLinksByParent, syncSocialLinksEntries } from "../../services/socialLinksService";
import { fetchAddressDetailsByParent } from "../../services/addressService";
import { fetchPasskeyDetailsByParent, syncPasskeyEntries } from "../../services/passkeyService";
import { handleSubmitProfile as submitProfile, fetchProfileData, fetchAllRelatedData } from "../../services/profileService";
import { encryptData } from "../../components/FormComponents/IDCardFields";
import { AddBankDialog, EditBankDialog, DeleteBankDialog } from "../../components/BankDetails";
import { AddIDCardDialog, EditIDCardDialog, DeleteIDCardDialog } from "../../components/IDCards";
import { AddWorkExperienceDialog, EditWorkExperienceDialog, DeleteWorkExperienceDialog } from "../../components/WorkExperience";
import { AddEducationDialog, EditEducationDialog, DeleteEducationDialog } from "../../components/Education";
import { AddSocialLinkDialog, EditSocialLinkDialog, DeleteSocialLinkDialog } from "../../components/SocialLinks";
import { AddPasskeyDialog, EditPasskeyDialog, DeletePasskeyDialog } from "../../components/Passkeys";
import { getSocialPlatformConfig } from "../../utils/socialLinks";

// Helper function to decode HTML entities
const decodeHTMLEntities = (text) => {
  if (!text) return text;
  const textArea = document.createElement("textarea");
  textArea.innerHTML = text;
  return textArea.value;
};

function Overview() {
  const [profile, setProfileData] = useState([]);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [educationDetails, setEducationDetails] = useState([]);
  const [workDetails, setWorkDetails] = useState([]);
  const [idCardDetails, setIDCardDetails] = useState([]);
  const [visibleIDCards, setVisibleIDCards] = useState({}); // Track visibility for each ID card
  const [editingIDCardEntry, setEditingIDCardEntry] = useState(null); // Track which ID card is being edited
  const [deleteIDCardConfirmOpen, setDeleteIDCardConfirmOpen] = useState(false); // Delete ID card confirmation dialog
  const [imagePreview, setImagePreview] = useState({ open: false, src: "", title: "" });
  const [idCardToDelete, setIdCardToDelete] = useState(null); // ID card entry to delete
  const [addIDCardDialogOpen, setAddIDCardDialogOpen] = useState(false); // Add ID card dialog state
  const [editingWorkEntry, setEditingWorkEntry] = useState(null); // Track which work experience is being edited
  const [deleteWorkConfirmOpen, setDeleteWorkConfirmOpen] = useState(false); // Delete work experience confirmation dialog
  const [workToDelete, setWorkToDelete] = useState(null); // Work experience entry to delete
  const [addWorkDialogOpen, setAddWorkDialogOpen] = useState(false); // Add work experience dialog state
  const [editingEducationEntry, setEditingEducationEntry] = useState(null); // Track which education is being edited
  const [deleteEducationConfirmOpen, setDeleteEducationConfirmOpen] = useState(false); // Delete education confirmation dialog
  const [educationToDelete, setEducationToDelete] = useState(null); // Education entry to delete
  const [addEducationDialogOpen, setAddEducationDialogOpen] = useState(false); // Add education dialog state
  const [bankDetails, setBankDetails] = useState([]);
  const [visibleBankAccounts, setVisibleBankAccounts] = useState({}); // Track visibility for each bank account
  const [editingBankEntry, setEditingBankEntry] = useState(null); // Track which bank is being edited
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false); // Delete confirmation dialog
  const [bankToDelete, setBankToDelete] = useState(null); // Bank entry to delete
  const [addBankDialogOpen, setAddBankDialogOpen] = useState(false); // Add bank dialog state
  const [socialLinksDetails, setSocialLinksDetails] = useState([]);
  const [addressDetails, setAddressDetails] = useState([]);
  const [editingSocialLinkEntry, setEditingSocialLinkEntry] = useState(null); // Track which social link is being edited
  const [deleteSocialLinkConfirmOpen, setDeleteSocialLinkConfirmOpen] = useState(false); // Delete social link confirmation dialog
  const [socialLinkToDelete, setSocialLinkToDelete] = useState(null); // Social link entry to delete
  const [addSocialLinkDialogOpen, setAddSocialLinkDialogOpen] = useState(false); // Add social link dialog state
  const [passkeyDetails, setPasskeyDetails] = useState([]);
  const [editingPasskeyEntry, setEditingPasskeyEntry] = useState(null); // Track which passkey is being edited
  const [deletePasskeyConfirmOpen, setDeletePasskeyConfirmOpen] = useState(false); // Delete passkey confirmation dialog
  const [passkeyToDelete, setPasskeyToDelete] = useState(null); // Passkey entry to delete
  const [addPasskeyDialogOpen, setAddPasskeyDialogOpen] = useState(false); // Add passkey dialog state
  const [visiblePasskeys, setVisiblePasskeys] = useState({}); // Track visibility for each passkey
  const [viewMode, setViewMode] = useState('detailed'); // 'detailed' or 'short' view mode
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // Try to read from localStorage first, fall back to Redux store values
  const reduxUserId = useSelector((state) =>
    state.session.setUserId ? state.session.setUserId.value : null
  );
  const reduxSessionId = useSelector((state) => state.session.sessionId);

  const tryParseJSON = (str) => {
    try {
      return JSON.parse(str);
    } catch {
      return null;
    }
  };

  const findInObject = (obj, predicate) => {
    if (!obj || typeof obj !== "object") return null;
    if (predicate(obj)) return obj;
    for (const k of Object.keys(obj)) {
      const res = findInObject(obj[k], predicate);
      if (res) return res;
    }
    return null;
  };

  // sessionId resolution
  let sessionId = localStorage.getItem("sessionId") || localStorage.getItem("session_id") || null;

  if (!sessionId) {
    const ssRaw = localStorage.getItem("sessionState");
    const ssParsed = tryParseJSON(ssRaw);
    if (ssParsed) {
      const found = findInObject(
        ssParsed,
        (o) =>
          (o && (o.sessionId || o.session_id)) ||
          (o && typeof o === "string" && (o.startsWith("1") || o.length > 10))
      );
      if (found) {
        // prefer explicit keys
        sessionId = found.sessionId || found.session_id || found;
      } else {
        // fallback: search for any key named sessionId deeper
        const s = findInObject(
          ssParsed,
          (o) => o && Object.prototype.hasOwnProperty.call(o, "sessionId")
        );
        sessionId = s?.sessionId || null;
      }
    }
  }

  if (!sessionId && reduxSessionId) sessionId = reduxSessionId;

  // user_id resolution
  const extractIdFromRaw = (raw) => {
    if (!raw) return null;
    const parsed = tryParseJSON(raw);
    if (parsed && typeof parsed === "object") {
      if (parsed.value) return parsed.value;
      if (parsed.user_id) return parsed.user_id;
      if (parsed.name === "user_id" && parsed.value) return parsed.value;
    }
    return raw;
  };

  let user_id = null;
  const userKeys = ["user_id", "userId", "setUserId", "userId", "userId"];
  for (const k of userKeys) {
    const raw = localStorage.getItem(k);
    const id = extractIdFromRaw(raw);
    if (id) {
      user_id = id;
      break;
    }
  }

  if (!user_id) {
    const ssRaw = localStorage.getItem("sessionState");
    const ssParsed = tryParseJSON(ssRaw);
    if (ssParsed) {
      // look for object like { name: "user_id", value: "1" } or setUserId.{value}
      const byName = findInObject(ssParsed, (o) => o && o.name === "user_id" && o.value);
      if (byName) {
        user_id = byName.value;
      } else if (ssParsed.setUserId && ssParsed.setUserId.value) {
        user_id = ssParsed.setUserId.value;
      } else {
        // generic search for any property named user_id or value fields that look like an id
        const byProp = findInObject(
          ssParsed,
          (o) =>
            o && (o.user_id || (o.value && typeof o.value === "string" && /^\d+$/.test(o.value)))
        );
        user_id = byProp?.user_id || byProp?.value || null;
      }
    }
  }

  if (!user_id && reduxUserId) user_id = reduxUserId;

  // Helper function to decode HTML entities
  const decodeHTML = (html) => {
    if (!html) return '';
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  // getSocialPlatformConfig now shared from utils/socialLinks

  // Auto-hide success toast after 3 seconds
  useEffect(() => {
    if (successSB) {
      const timer = setTimeout(() => {
        setSuccessSB(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [successSB]);

  // Auto-hide error toast after 3 seconds
  useEffect(() => {
    if (errorSB) {
      const timer = setTimeout(() => {
        setErrorSB(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [errorSB]);

  useEffect(() => {
    if (!sessionId) {
      navigate("/authentication/sign-in");
    }
  }, [sessionId, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      const apiUrl = "https://seltentechnologiesdemo.com/moona-backend/service/v4_1/rest.php";
      const method = "get_entry_list";
      const input_type = "JSON";
      const response_type = "JSON";
      const rest_data = JSON.stringify({
        session: sessionId,
        module_name: "Users",
        // select_fields: [
        //   "id",
        //   "user_name",
        //   "first_name",
        //   "last_name",
        //   "email_c",
        //   "phone_mobile",
        //   "address_street",
        //   "address_state",
        //   "address_country",
        //   "address_city",
        //   "address_postalcode",
        //   "address_c",
        //   "village_c",
        //   "taluk_c",
        //   "referrer_c",
        //   "selfdescription_c",
        //   "dob_c",
        //   "aadhaar_c",
        //   "caste_c",
        //   "religion_c",
        //   "instagram_c",
        //   "facebook_c",
        //   "youtube_c",
        //   "linkedin_c",
        //   "threads_c",
        //   // Personal Information
        //   "address1_c",
        //   "address2_c",
        //   "district_c",
        //   "age_c",
        //   "alivestatus_c",
        //   "birthplace_c",
        //   "bloodgroup_c",
        //   "dateofdeath_c",
        //   "deathplace_c",
        //   "deathreason_c",
        //   "deathaddress_c",
        //   "deatharea_c",
        //   "deathpincode_c",
        //   "deathcity_c",
        //   "deathstate_c",
        //   "deathcountry_c",
        //   "disability_c",
        //   "disabilitytype_c",
        //   "gender_c",
        //   // Language Details
        //   "languagesknown_c",
        //   "mothertongue_c",
        //   // Marital Details
        //   "maritalstatus_c",
        //   "marriagedate_c",
        //   "marriageplace_c",
        //   // Economic Status
        //   "economical_status_c",
        //    "photo_url_c",
        // ],
      });

      const fullUrl = `${apiUrl}?method=${method}&input_type=${input_type}&response_type=${response_type}&rest_data=${encodeURIComponent(
        rest_data
      )}`;

      try {
        const response = await axios.get(fullUrl);
        console.log("user api res", response)
        if (response.data.name === "Invalid Session ID") {
          navigate("/authentication/sign-in");
        }
        const entryList = response.data.entry_list;
        const products = entryList.map((entry) => entry.name_value_list);
        const filteredProfiles = products.filter((item) => item.id.value === user_id);
        const profileData = filteredProfiles.length > 0 ? filteredProfiles[0] : null;
        setProfileData(profileData);
        console.log("profile data", profileData)

        if (user_id) {
          try {
            const eduEntries = await fetchEducationDetailsByParent(sessionId, user_id);
            setEducationDetails(eduEntries);
          } catch (eduError) {
            console.error("Error fetching education details:", eduError);
            setEducationDetails([]);
          }

          try {
            const workEntries = await fetchWorkDetailsByParent(sessionId, user_id);
            setWorkDetails(workEntries);
          } catch (workError) {
            console.error("Error fetching work details:", workError);
            setWorkDetails([]);
          }

          try {
            console.log('🔍 Profile: Fetching ID cards with sessionId:', sessionId);
            console.log('🔍 Profile: User ID:', user_id);
            const idCardEntries = await fetchIDCardDetailsByParent(sessionId, user_id);
            console.log('✅ Profile: ID Card entries fetched:', idCardEntries.length, 'entries');
            console.log('📸 Profile: First entry images:', idCardEntries[0]?.image1?.substring(0, 100), idCardEntries[0]?.image2?.substring(0, 100));
            setIDCardDetails(idCardEntries);
          } catch (idCardError) {
            console.error("Error fetching ID card details:", idCardError);
            setIDCardDetails([]);
          }

          try {
            const bankEntries = await fetchBankDetailsByParent(sessionId, user_id);
            setBankDetails(bankEntries);
          } catch (bankError) {
            console.error("Error fetching bank details:", bankError);
            setBankDetails([]);
          }

          try {
            const socialLinksEntries = await fetchSocialLinksByParent(sessionId, user_id);
            setSocialLinksDetails(socialLinksEntries);
          } catch (socialLinksError) {
            console.error("Error fetching social links:", socialLinksError);
            setSocialLinksDetails([]);
          }

          try {
            const addressEntries = await fetchAddressDetailsByParent(sessionId, user_id);
            setAddressDetails(addressEntries);
          } catch (addressError) {
            console.error("Error fetching address details:", addressError);
            setAddressDetails([]);
          }

          try {
            const passkeyEntries = await fetchPasskeyDetailsByParent(sessionId, user_id);
            setPasskeyDetails(passkeyEntries);
          } catch (passkeyError) {
            console.error("Error fetching passkey details:", passkeyError);
            setPasskeyDetails([]);
          }
        }
      } catch (error) {
        if (error.response) {
          console.error("An error occurred during get data:", error.response.data);
        } else if (error.request) {
          console.error("No response received:", error.request);
        } else {
          console.error("Error setting up request:", error.message);
        }
      }
    };

    if (sessionId) {
      fetchData();
    }
  }, [sessionId]);

  const handleCancel = () => {
    navigate(-1); // Go back to previous page
  };

  const handleOpenEditDialog = () => {
    setEditDialogOpen(true);
    setError(null);
  };

  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
    setError(null);
  };

  // Helper function to call SuiteCRM API
  const callSuiteCrmApi = async (method, data, retries = 2) => {
    const apiUrl = "https://seltentechnologiesdemo.com/moona-backend/service/v4_1/rest.php";

    const params = new URLSearchParams();
    params.append("method", method);
    params.append("input_type", "JSON");
    params.append("response_type", "JSON");
    params.append("rest_data", JSON.stringify(data));

    try {
      const response = await axios.post(apiUrl, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      return response.data;
    } catch (error) {
      if (retries > 0) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return callSuiteCrmApi(method, data, retries - 1);
      }
      throw error;
    }
  };

  const handleSubmitProfile = async (formData) => {
    setIsSubmitting(true);
    setError(null);

    try {
      // Call the profile service to handle submission
      await submitProfile(formData, user_id, sessionId, dispatch, setUserPhoto);

      // Fetch updated profile data
      const updatedProfile = await fetchProfileData(sessionId, user_id);
      setProfileData(updatedProfile);
      console.log("profileData", updatedProfile);

      // Fetch all related data
      const relatedData = await fetchAllRelatedData(sessionId, user_id);
      setEducationDetails(relatedData.educationEntries);
      setWorkDetails(relatedData.workEntries);
      setIDCardDetails(relatedData.idCardEntries);
      setBankDetails(relatedData.bankEntries);
      setSocialLinksDetails(relatedData.socialLinksEntries);

      setEditDialogOpen(false);
      setSnackbarMessage("Profile updated successfully!");
      setSuccessSB(true);
    } catch (error) {
      console.error("Error updating profile:", error);
      setError(error.message || "Failed to update profile");
      setSnackbarMessage(error.message || "Failed to update profile");
      setErrorSB(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Helper component for info row
  const InfoRow = ({ icon, label, value }) => {
    if (!value) return null;
    return (
      <MDBox display="flex" alignItems="center" mb={2}>
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="2.5rem"
          height="2.5rem"
          borderRadius="md"
          shadow="md"
          color="white"
          bgColor="info"
          mr={2}
        >
          <Icon fontSize="small">{icon}</Icon>
        </MDBox>
        <MDBox>
          <MDTypography variant="button" fontWeight="medium" color="text">
            {label}
          </MDTypography>
          <MDTypography variant="body2" color="text">
            {value}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  };

  // Helper to render education section from new education details
  const renderEducationDetail = (entry, index) => {
    if (!entry) return null;

    // If qualification is "Others" (or "Other"), show others_c value, otherwise show qualification
    const rawQualEntry = (entry.qualification || "").toString().trim();
    const isOthersQualEntry = /^others?$/i.test(rawQualEntry);
    const displayQualification = isOthersQualEntry && entry.others_c 
      ? decodeHTMLEntities(entry.others_c) 
      : decodeHTMLEntities(entry.qualification || entry.name || `Education ${index + 1}`);
    const imageSrc = typeof entry.image === "string" ? entry.image.trim() : "";
    const hasImage = imageSrc.startsWith("data:");

    return (
      <Card
        key={entry.id || index}
        sx={{
          p: 2,
          mb: 2,
          boxShadow: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <MDTypography variant="h6" fontWeight="medium" color="info">
            🎓 {displayQualification}
          </MDTypography>
          <MDBox display="flex" gap={1}>
            <IconButton
              size="small"
              color="info"
              onClick={() => setEditingEducationEntry(entry)}
              sx={{ p: 0.5 }}
            >
              <Icon fontSize="small">edit</Icon>
            </IconButton>
            <IconButton
              size="small"
              color="error"
              onClick={() => {
                setEducationToDelete(entry);
                setDeleteEducationConfirmOpen(true);
              }}
              sx={{ p: 0.5 }}
            >
              <Icon fontSize="small">delete</Icon>
            </IconButton>
          </MDBox>
        </MDBox>
        {hasImage && (
          <Box
            sx={{
              mb: 2,
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.300",
              backgroundColor: "grey.50",
              p: 1,
              textAlign: "center",
            }}
          >
            <MDTypography variant="caption" color="text.secondary" display="block" mb={0.5}>
              School/Institute ID
            </MDTypography>
            <Box
              component="img"
              src={imageSrc}
              alt="School or Institute ID"
              sx={{
                width: "100%",
                maxHeight: 180,
                objectFit: "contain",
                borderRadius: 1,
                cursor: "pointer",
              }}
              onClick={() => openImagePreview(imageSrc, "School/Institute ID")}
              onError={(event) => {
                console.error("Failed to render education image", { id: entry.id });
                event.currentTarget.style.display = "none";
              }}
            />
          </Box>
        )}
        <Grid container spacing={2} sx={{ flexGrow: 1 }}>
          {entry.qualification && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Qualification
              </MDTypography>
              <MDTypography variant="body2">{displayQualification}</MDTypography>
            </Grid>
          )}
          {entry.board && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Board/University
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.board)}</MDTypography>
            </Grid>
          )}
          {entry.course && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Course
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.course)}</MDTypography>
            </Grid>
          )}
          {entry.educationtype && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Education Type
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.educationtype)}</MDTypography>
            </Grid>
          )}
          {entry.institute && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Institute/School
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.institute)}</MDTypography>
            </Grid>
          )}
          {(entry.instituecity || entry.institutestate || entry.institutecountry) && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Location
              </MDTypography>
              <MDTypography variant="body2">
                {[
                  decodeHTMLEntities(entry.instituecity),
                  decodeHTMLEntities(entry.institutestate),
                  decodeHTMLEntities(entry.institutecountry),
                ]
                  .filter(Boolean)
                  .join(", ")}
              </MDTypography>
            </Grid>
          )}
          {(entry.startyear_c || entry.endyear_c) && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Duration
              </MDTypography>
              <MDTypography variant="body2">
                {entry.startyear_c || "N/A"} -{" "}
                {entry.currentlystudying_c === '1' ? "Present" : entry.endyear_c || "N/A"}
              </MDTypography>
            </Grid>
          )}
          {entry.grade && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Grade/Mark
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.grade)}</MDTypography>
            </Grid>
          )}
          {entry.degreetype && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Degree Type
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.degreetype)}</MDTypography>
            </Grid>
          )}
          {entry.institutetype && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Institute Type
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.institutetype)}</MDTypography>
            </Grid>
          )}
          {entry.institutepincode && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Pincode
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.institutepincode)}</MDTypography>
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  // Helper to render work experience section
  const renderWorkDetail = (entry, index) => {
    if (!entry) return null;

    // Check if entry has any meaningful data (not just empty strings or N/A values)
    const hasCompany = entry.companyname && entry.companyname.trim();
    const hasDesignation = entry.designation && entry.designation.trim();
    const hasDepartment = entry.department && entry.department.trim();
    const hasSector = entry.sector && entry.sector.trim();
    const hasEmploymentType = entry.employmenttype && entry.employmenttype.trim();
    const hasStartDate = entry.startdate && entry.startdate.trim();
    const hasEndDate = entry.enddate && entry.enddate.trim();
    const hasLocation =
      (entry.city && entry.city.trim()) ||
      (entry.state && entry.state.trim()) ||
      (entry.country && entry.country.trim());
    const hasAddress = entry.address && entry.address.trim();
    const hasDescription = entry.description && entry.description.trim();
    const hasImage =
      entry.image && typeof entry.image === "string" && entry.image.startsWith("data:");

    // If entry has no meaningful data, don't render it
    if (
      !hasCompany &&
      !hasDesignation &&
      !hasDepartment &&
      !hasSector &&
      !hasEmploymentType &&
      !hasStartDate &&
      !hasEndDate &&
      !hasLocation &&
      !hasAddress &&
      !hasDescription &&
      !hasImage
    ) {
      return null;
    }

    const imageSrc = hasImage ? entry.image : null;

    return (
      <Card
        key={entry.id || index}
        sx={{
          p: 2,
          mb: 2,
          boxShadow: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <MDTypography variant="h6" fontWeight="medium" color="primary">
            💼 {decodeHTMLEntities(entry.companyname || entry.name || `Work Experience ${index + 1}`)}
          </MDTypography>
          <MDBox display="flex" gap={1}>
            <IconButton
              size="small"
              color="info"
              onClick={() => setEditingWorkEntry(entry)}
              sx={{ p: 0.5 }}
            >
              <Icon fontSize="small">edit</Icon>
            </IconButton>
            <IconButton
              size="small"
              color="error"
              onClick={() => {
                setWorkToDelete(entry);
                setDeleteWorkConfirmOpen(true);
              }}
              sx={{ p: 0.5 }}
            >
              <Icon fontSize="small">delete</Icon>
            </IconButton>
          </MDBox>
        </MDBox>
        {imageSrc && (
          <Box
            sx={{
              mb: 2,
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.300",
              backgroundColor: "grey.50",
              p: 1,
              textAlign: "center",
            }}
          >
            <MDTypography variant="caption" color="text.secondary" display="block" mb={0.5}>
              ID Card Image
            </MDTypography>
            <Box
              component="img"
              src={imageSrc}
              alt="Work experience ID"
              sx={{
                width: "100%",
                maxHeight: 180,
                objectFit: "contain",
                borderRadius: 1,
                cursor: "pointer",
              }}
              onClick={() => openImagePreview(imageSrc, "Work Experience ID Card")}
              onError={(event) => {
                console.error("Failed to render work experience image", { id: entry.id });
                event.currentTarget.style.display = "none";
              }}
            />
          </Box>
        )}
        <Grid container spacing={2} sx={{ flexGrow: 1 }}>
          {hasCompany && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Company
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.companyname)}</MDTypography>
            </Grid>
          )}
          {hasDesignation && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Designation
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.designation)}</MDTypography>
            </Grid>
          )}
          {hasDepartment && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Department
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.department)}</MDTypography>
            </Grid>
          )}
          {hasSector && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Sector/Industry
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.sector)}</MDTypography>
            </Grid>
          )}
          {hasEmploymentType && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Employment Type
              </MDTypography>
              <MDTypography variant="body2">
                {decodeHTMLEntities(entry.employmenttype)}
              </MDTypography>
            </Grid>
          )}
          {(hasStartDate || hasEndDate || entry.currentlyworking) && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Duration
              </MDTypography>
              <MDTypography variant="body2">
                {entry.startdate || "N/A"} -{" "}
                {entry.currentlyworking === true ||
                entry.currentlyworking === 1 ||
                entry.currentlyworking === "1"
                  ? "Present"
                  : entry.enddate || "N/A"}
              </MDTypography>
            </Grid>
          )}
          {hasLocation && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Location
              </MDTypography>
              <MDTypography variant="body2">
                {[
                  decodeHTMLEntities(entry.city),
                  decodeHTMLEntities(entry.state),
                  decodeHTMLEntities(entry.country),
                ]
                  .filter(Boolean)
                  .join(", ")}
              </MDTypography>
            </Grid>
          )}
          {hasAddress && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Address
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.address)}</MDTypography>
            </Grid>
          )}
          {hasDescription && (
            <Grid item xs={12}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Job Description
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.description)}</MDTypography>
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  // Helper to render education section (old format for backward compatibility)
  const renderEducation = (num) => {
    const edu = decodeHTMLEntities(profile[`education${num}_c`]?.value);
    const degree = profile[`degree${num}_c`]?.value;
    const course = profile[`course${num}_c`]?.value;
    const type = profile[`educationtype${num}_c`]?.value;
    const institute = profile[`institute${num}_c`]?.value;
    const year = profile[`yearofpassing${num}_c`]?.value;

    if (!edu && !type && !institute && !year && !degree && !course) return null;

    return (
      <Card
        sx={{
          p: 2,
          mb: 2,
          boxShadow: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <MDTypography variant="h6" fontWeight="medium" color="info" mb={1}>
          🎓 Education {num}
        </MDTypography>
        <Grid container spacing={2} sx={{ flexGrow: 1 }}>
          {edu && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Qualification
              </MDTypography>
              <MDTypography variant="body2">{edu}</MDTypography>
            </Grid>
          )}
          {degree && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Degree
              </MDTypography>
              <MDTypography variant="body2">{degree}</MDTypography>
            </Grid>
          )}
          {course && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Course / Specialization
              </MDTypography>
              <MDTypography variant="body2">{course}</MDTypography>
            </Grid>
          )}
          {type && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Type
              </MDTypography>
              <MDTypography variant="body2">{type}</MDTypography>
            </Grid>
          )}
          {institute && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Institute
              </MDTypography>
              <MDTypography variant="body2">{institute}</MDTypography>
            </Grid>
          )}
          {year && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Year of Passing
              </MDTypography>
              <MDTypography variant="body2">{year}</MDTypography>
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  // Toggle visibility for a specific ID card
  const toggleIDCardVisibility = (cardId) => {
    setVisibleIDCards((prev) => ({
      ...prev,
      [cardId]: !prev[cardId],
    }));
  };

  const toggleBankAccountVisibility = (accountId) => {
    setVisibleBankAccounts((prev) => ({
      ...prev,
      [accountId]: !prev[accountId],
    }));
  };

  const openImagePreview = (src, title) => {
    if (!src) return;
    setImagePreview({ open: true, src, title });
  };

  const closeImagePreview = () => {
    setImagePreview({ open: false, src: "", title: "" });
  };

  // Toggle visibility for a specific passkey
  const togglePasskeyVisibility = (passkeyId) => {
    setVisiblePasskeys((prev) => ({
      ...prev,
      [passkeyId]: !prev[passkeyId],
    }));
  };

  // Helper to mask sensitive data
  const maskData = (data, visible) => {
    if (!data || visible) return data;
    return "••••••••••";
  };

  // Helper to render ID card detail
  const renderIDCardDetail = (entry, index) => {
    if (!entry) return null;

    const cardId = entry.id || `idcard-${index}`;
    const isVisible = visibleIDCards[cardId] || false;

    const hasIDType = entry.idtype && entry.idtype.trim();
    const hasIDCardName = entry.name && entry.name.trim();
    const hasIDNumber = entry.idnumber && entry.idnumber.trim();
    const hasIssueDate = entry.issuedate && entry.issuedate.trim();
    const hasExpiryDate = entry.expirydate && entry.expirydate.trim();
    const hasDescription = entry.description && entry.description.trim();

    const isDataUri = (value) => typeof value === "string" && value.startsWith("data:");
    const frontImage = isDataUri(entry.image1) ? entry.image1 : null;
    const backImage = isDataUri(entry.image2) ? entry.image2 : null;

    // If entry has no meaningful data, don't render it
    if (!hasIDType && !hasIDCardName && !hasIDNumber && !hasIssueDate && !hasExpiryDate && !hasDescription) {
      return null;
    }

    return (
      <Card
        key={cardId}
        sx={{
          p: 2,
          mb: 2,
          boxShadow: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        {/* Action Icons */}
        <MDBox
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            display: "flex",
            gap: 1,
            zIndex: 1,
          }}
        >
          <IconButton
            size="small"
            onClick={() => setEditingIDCardEntry(entry)}
            sx={{ color: "primary.main" }}
          >
            <Icon fontSize="small">edit</Icon>
          </IconButton>
          <IconButton
            size="small"
            onClick={() => {
              setIdCardToDelete(entry);
              setDeleteIDCardConfirmOpen(true);
            }}
            sx={{ color: "error.main" }}
          >
            <Icon fontSize="small">delete</Icon>
          </IconButton>
          <IconButton
            size="small"
            onClick={() => toggleIDCardVisibility(cardId)}
            sx={{ color: isVisible ? "primary.main" : "secondary.main" }}
          >
            <Icon fontSize="small">
              {isVisible ? "visibility" : "visibility_off"}
            </Icon>
          </IconButton>
        </MDBox>

        {(frontImage || backImage) && (
          <MDBox
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 1.5,
              mb: 2,
              alignItems: "stretch",
            }}
          >
            {frontImage && (
              <MDBox sx={{ flex: 1, minWidth: 140 }}>
                <MDTypography variant="caption" color="text.secondary" display="block" mb={0.5}>
                  Front Page
                </MDTypography>
                <Box
                  component="img"
                  src={frontImage}
                  alt="ID card front page"
                  sx={{
                    width: "100%",
                    maxHeight: 160,
                    borderRadius: 1,
                    objectFit: "contain",
                    border: "1px solid",
                    borderColor: "grey.300",
                    backgroundColor: "grey.50",
                    cursor: "pointer",
                  }}
                  onClick={() => openImagePreview(frontImage, "Front Page Image")}
                  onError={(event) => {
                    console.error("Failed to render ID card front image", { id: cardId });
                    event.currentTarget.style.display = "none";
                  }}
                />
              </MDBox>
            )}

            {backImage && (
              <MDBox sx={{ flex: 1, minWidth: 140 }}>
                <MDTypography variant="caption" color="text.secondary" display="block" mb={0.5}>
                  Back Page
                </MDTypography>
                <Box
                  component="img"
                  src={backImage}
                  alt="ID card back page"
                  sx={{
                    width: "100%",
                    maxHeight: 160,
                    borderRadius: 1,
                    objectFit: "contain",
                    border: "1px solid",
                    borderColor: "grey.300",
                    backgroundColor: "grey.50",
                    cursor: "pointer",
                  }}
                  onClick={() => openImagePreview(backImage, "Back Page Image")}
                  onError={(event) => {
                    console.error("Failed to render ID card back image", { id: cardId });
                    event.currentTarget.style.display = "none";
                  }}
                />
              </MDBox>
            )}
          </MDBox>
        )}

        <MDTypography variant="h6" fontWeight="medium" color="warning" mb={1} pr={4}>
          🆔 {decodeHTMLEntities(entry.idtype || `ID Card ${index + 1}`)}
        </MDTypography>
        
        <Grid container spacing={2} sx={{ flexGrow: 1 }}>
          {hasIDCardName && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Name on ID Card
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.name)}</MDTypography>
            </Grid>
          )}
          {hasIDNumber && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                ID Number
              </MDTypography>
              <MDTypography variant="body2" sx={{ fontFamily: "monospace" }}>
                {maskData(entry.idnumber, isVisible)}
              </MDTypography>
            </Grid>
          )}
          {hasIssueDate && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Issue Date
              </MDTypography>
              <MDTypography variant="body2">{entry.issuedate}</MDTypography>
            </Grid>
          )}
          {hasExpiryDate && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Expiry Date
              </MDTypography>
              <MDTypography variant="body2">
                {maskData(entry.expirydate, isVisible)}
              </MDTypography>
            </Grid>
          )}
          {hasDescription && (
            <Grid item xs={12}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Additional Notes
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.description)}</MDTypography>
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  // Helper to render bank detail
  const renderBankDetail = (entry, index) => {
    if (!entry) return null;

    const accountId = entry.id || `bank-${index}`;
    const isVisible = visibleBankAccounts[accountId] || false;

    const passbookImage =
      entry.image && typeof entry.image === "string" && entry.image.startsWith("data:")
        ? entry.image
        : null;

    const hasAccountHolderName = entry.accountholdername && entry.accountholdername.trim();
    const hasAccountNumber = entry.accountnumber && entry.accountnumber.trim();
    const hasIFSC = entry.ifsc && entry.ifsc.trim();
    const hasAccountType = entry.accounttype && entry.accounttype.trim();
    const hasBankName = entry.bankname && entry.bankname.trim();
    const hasBranch = entry.branch && entry.branch.trim();
    const hasBankCountry = entry.bankcountry && entry.bankcountry.trim();
    const hasStatus = entry.status && entry.status.trim();
    const hasDescription = entry.description && entry.description.trim();

    // If entry has no meaningful data, don't render it
    if (!hasAccountHolderName && !hasAccountNumber && !hasIFSC && !hasBankName) {
      return null;
    }

    return (
      <Card
        key={accountId}
        sx={{
          p: 2,
          mb: 2,
          boxShadow: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        {/* Action Icons: Edit, Delete, Eye */}
        <MDBox
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            display: "flex",
            gap: 1,
            zIndex: 1,
          }}
        >
          <IconButton
            size="small"
            onClick={() => setEditingBankEntry(entry)}
            sx={{ color: "info.main" }}
          >
            <Icon fontSize="small">edit</Icon>
          </IconButton>
          <IconButton
            size="small"
            onClick={() => {
              setBankToDelete(entry);
              setDeleteConfirmOpen(true);
            }}
            sx={{ color: "error.main" }}
          >
            <Icon fontSize="small">delete</Icon>
          </IconButton>
          <IconButton
            size="small"
            onClick={() => toggleBankAccountVisibility(accountId)}
            sx={{ color: isVisible ? "primary.main" : "secondary.main" }}
          >
            <Icon fontSize="small">
              {isVisible ? "visibility" : "visibility_off"}
            </Icon>
          </IconButton>
        </MDBox>

        <MDTypography variant="h6" fontWeight="medium" color="success" mb={1} pr={4}>
          🏦 {decodeHTMLEntities(entry.bankname || `Bank Account ${index + 1}`)}
        </MDTypography>

        {passbookImage && (
          <Box
            sx={{
              mb: 2,
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.300",
              backgroundColor: "grey.50",
              p: 1,
              textAlign: "center",
            }}
          >
            <MDTypography variant="caption" color="text.secondary" display="block" mb={0.5}>
              Passbook Image
            </MDTypography>
            <Box
              component="img"
              src={passbookImage}
              alt="Passbook"
              sx={{
                width: "100%",
                maxHeight: 180,
                objectFit: "contain",
                borderRadius: 1,
                cursor: "pointer",
              }}
              onClick={() => openImagePreview(passbookImage, "Passbook Image")}
              onError={(event) => {
                console.error("Failed to render bank passbook image", { id: accountId });
                event.currentTarget.style.display = "none";
              }}
            />
          </Box>
        )}
        
        <Grid container spacing={2} sx={{ flexGrow: 1 }}>
          {hasAccountHolderName && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Account Holder Name
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.accountholdername)}</MDTypography>
            </Grid>
          )}
          {hasAccountNumber && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Account Number
              </MDTypography>
              <MDTypography variant="body2" sx={{ fontFamily: "monospace" }}>
                {maskData(entry.accountnumber, isVisible)}
              </MDTypography>
            </Grid>
          )}
          {hasIFSC && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                IFSC Code
              </MDTypography>
              <MDTypography variant="body2" sx={{ fontFamily: "monospace" }}>
                {maskData(entry.ifsc, isVisible)}
              </MDTypography>
            </Grid>
          )}
          {hasAccountType && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Account Type
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.accounttype)}</MDTypography>
            </Grid>
          )}
          {hasBranch && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Branch
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.branch)}</MDTypography>
            </Grid>
          )}
          {hasBankCountry && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Bank Country
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.bankcountry)}</MDTypography>
            </Grid>
          )}
          {hasStatus && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Account Status
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.status)}</MDTypography>
            </Grid>
          )}
          {hasDescription && (
            <Grid item xs={12}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Additional Notes
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.description)}</MDTypography>
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  const renderSocialLink = (entry, index) => {
    if (!entry) return null;

    const hasType = entry.type && entry.type.trim();
    const hasLink = entry.link && entry.link.trim();

    // If entry has no meaningful data, don't render it
    if (!hasType && !hasLink) {
      return null;
    }

    const { platform, linkUrl } = getSocialPlatformConfig(entry);

    return (
      <Grid item xs={12} sm={6} md={4} lg={2.4} key={entry.id || `social-${index}`}>
        <MDBox position="relative">
          {/* Action Buttons */}
          <MDBox
            className="action-buttons"
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              display: "flex",
              gap: 0.5,
              zIndex: 10,
            }}
          >
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setEditingSocialLinkEntry(entry);
              }}
              sx={{
                "&:hover": { 
                  backgroundColor: "rgba(33, 150, 243, 0.1)",
                },
              }}
            >
              <Icon fontSize="small" color="info">edit</Icon>
            </IconButton>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setSocialLinkToDelete(entry);
                setDeleteSocialLinkConfirmOpen(true);
              }}
              sx={{
                "&:hover": { 
                  backgroundColor: "rgba(244, 67, 54, 0.1)",
                },
              }}
            >
              <Icon fontSize="small" color="error">delete</Icon>
            </IconButton>
          </MDBox>

          {/* Social Link Card */}
          <a
            href={linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
            onClick={(e) => {
              // Prevent navigation if clicking on action buttons
              const target = e.target;
              if (target.closest('.action-buttons')) {
                e.preventDefault();
              }
            }}
          >
            <MDBox
              textAlign="center"
              p={2}
              borderRadius="lg"
              sx={{
                bgcolor: "#f5f5f5",
                cursor: "pointer",
                transition: "all 0.3s",
                "&:hover": {
                  bgcolor: platform.color,
                  transform: "translateY(-5px)",
                  boxShadow: 3,
                  "& .MuiIcon-root, & .MuiTypography-root": {
                    color: platform.textColor || "white !important",
                  },
                },
              }}
            >
              <Icon fontSize="large" sx={{ color: platform.color }}>
                {platform.icon}
              </Icon>
              <MDTypography variant="button" display="block" mt={1}>
                {platform.displayName}
              </MDTypography>
              <MDTypography variant="caption" sx={{ wordBreak: "break-all" }}>
                {entry.link}
              </MDTypography>
            </MDBox>
          </a>
        </MDBox>
      </Grid>
    );
  };

  // Helper to render address details
  const renderAddressDetail = (entry, index) => {
    if (!entry) return null;

    let addressType = entry.addresstype_c || entry.addresstype || `Address ${index + 1}`;
    // Change "Current" to "Current Address" and "Permanent" to "Permanent Address"
    if (addressType === 'Current') addressType = 'Current Address';
    if (addressType === 'Permanent') addressType = 'Permanent Address';
    
    const hasAddress = entry.address && entry.address.trim();
    const hasStreet = entry.street && entry.street.trim();
    const hasVillage = entry.village && entry.village.trim();
    const hasPincode = entry.pincode && entry.pincode.trim();
    const hasTaluk = entry.taluk && entry.taluk.trim();
    const hasDistrict = entry.district && entry.district.trim();
    const hasState = entry.state && entry.state.trim();
    const hasCountry = entry.country && entry.country.trim();

    // If entry has no meaningful data, don't render it
    if (!hasAddress && !hasStreet && !hasVillage && !hasPincode && !hasTaluk && !hasDistrict && !hasState && !hasCountry) {
      return null;
    }

    // Use same purple color for all address headings
    const headingColor = '#9c27b0';

    return (
      <Card
        key={entry.id || index}
        sx={{
          p: 2,
          mb: 2,
          boxShadow: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <MDTypography variant="h6" fontWeight="medium" mb={1} sx={{ color: headingColor }}>
          🏠 {addressType}
        </MDTypography>
        <Grid container spacing={2} sx={{ flexGrow: 1 }}>
          {hasAddress && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Address
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.address)}</MDTypography>
            </Grid>
          )}
          {hasStreet && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Street
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.street)}</MDTypography>
            </Grid>
          )}
          {hasVillage && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Village/Town
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.village)}</MDTypography>
            </Grid>
          )}
          {hasPincode && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Pincode
              </MDTypography>
              <MDTypography variant="body2">{entry.pincode}</MDTypography>
            </Grid>
          )}
          {hasTaluk && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Taluk
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.taluk)}</MDTypography>
            </Grid>
          )}
          {hasDistrict && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                District
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.district)}</MDTypography>
            </Grid>
          )}
          {hasState && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                State
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.state)}</MDTypography>
            </Grid>
          )}
          {hasCountry && (
            <Grid item xs={12} sm={6}>
              <MDTypography variant="caption" color="text" fontWeight="bold">
                Country
              </MDTypography>
              <MDTypography variant="body2">{decodeHTMLEntities(entry.country)}</MDTypography>
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header
        profile={profile}
        onEditClick={handleOpenEditDialog}
        educationDetails={educationDetails}
        workDetails={workDetails}
        idCardDetails={idCardDetails}
        bankDetails={bankDetails}
        addressDetails={addressDetails}
      >
        <MDBox mt={5} mb={3}>
          {/* View Mode Toggle */}
          <MDBox display="flex" justifyContent="flex-end" mb={2}>
            <MDButton
              variant={viewMode === 'short' ? 'contained' : 'outlined'}
              color="info"
              size="small"
              onClick={() => setViewMode('short')}
              sx={{ mr: 1 }}
            >
              <Icon sx={{ mr: 0.5 }}>view_agenda</Icon>
              Short View
            </MDButton>
            <MDButton
              variant={viewMode === 'detailed' ? 'contained' : 'outlined'}
              color="info"
              size="small"
              onClick={() => setViewMode('detailed')}
            >
              <Icon sx={{ mr: 0.5 }}>view_module</Icon>
              Detailed View
            </MDButton>
          </MDBox>

          {/* Short View */}
          {viewMode === 'short' && (
            <Card sx={{ boxShadow: 4, mb: 3, borderRadius: 2 }}>
              <MDBox p={3}>
                <Grid container spacing={2}>
                  {/* Personal Information */}
                  <Grid item xs={12}>
                    <MDBox display="flex" alignItems="center" mb={1}>
                      <Icon fontSize="medium" color="info" sx={{ mr: 1 }}>person</Icon>
                      <MDTypography variant="h5" fontWeight="bold" color="info">
                        Personal Information
                      </MDTypography>
                    </MDBox>
                    <Divider sx={{ mb: 1.5, borderBottomWidth: 2 }} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Name:</MDTypography>
                    <MDTypography variant="body2" sx={{ wordBreak: 'break-word' }}>
                      {decodeHTML(`${profile.first_name?.value || ''} ${profile.last_name?.value || ''}`)}
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Email:</MDTypography>
                    <MDTypography variant="body2" sx={{ wordBreak: 'break-all' }}>{decodeHTML(profile.email_c?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Mobile:</MDTypography>
                    <MDTypography variant="body2">{decodeHTML(profile.phone_mobile?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Date of Birth:</MDTypography>
                    <MDTypography variant="body2">{decodeHTML(profile.dob_c?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Age:</MDTypography>
                    <MDTypography variant="body2">{decodeHTML(profile.age_c?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Gender:</MDTypography>
                    <MDTypography variant="body2">{decodeHTML(profile.gender_c?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Blood Group:</MDTypography>
                    <MDTypography variant="body2">{decodeHTML(profile.bloodgroup_c?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Birth Place:</MDTypography>
                    <MDTypography variant="body2" sx={{ wordBreak: 'break-word' }}>{decodeHTML(profile.birthplace_c?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Aadhaar:</MDTypography>
                    <MDTypography variant="body2">{decodeHTML(profile.aadhaar_c?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Caste:</MDTypography>
                    <MDTypography variant="body2">{decodeHTML(profile.caste_c?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Religion:</MDTypography>
                    <MDTypography variant="body2">{decodeHTML(profile.religion_c?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Marital Status:</MDTypography>
                    <MDTypography variant="body2">{decodeHTML(profile.maritalstatus_c?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Economic Status:</MDTypography>
                    <MDTypography variant="body2">{decodeHTML(profile.economical_status_c?.value) || 'N/A'}</MDTypography>
                  </Grid>

                  {/* Language Information */}
                  <Grid item xs={12} mt={2}>
                    <MDBox display="flex" alignItems="center" mb={1}>
                      <Icon fontSize="medium" color="error" sx={{ mr: 1 }}>language</Icon>
                      <MDTypography variant="h5" fontWeight="bold" color="error">
                        Language Details
                      </MDTypography>
                    </MDBox>
                    <Divider sx={{ mb: 1.5, borderBottomWidth: 2 }} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Mother Tongue:</MDTypography>
                    <MDTypography variant="body2">{decodeHTML(profile.mothertongue_c?.value) || 'N/A'}</MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography variant="caption" color="text" fontWeight="bold" display="block">Languages Known:</MDTypography>
                    <MDTypography variant="body2" sx={{ wordBreak: 'break-word' }}>{decodeHTML(profile.languagesknown_c?.value) || 'N/A'}</MDTypography>
                  </Grid>

                  {/* Address Details */}
                  {addressDetails && addressDetails.length > 0 && (
                    <>
                      <Grid item xs={12} mt={2}>
                        <MDBox display="flex" alignItems="center" mb={1}>
                          <Icon fontSize="medium" sx={{ mr: 1, color: '#9c27b0' }}>location_on</Icon>
                          <MDTypography variant="h5" fontWeight="bold">
                            Address Details ({addressDetails.length})
                          </MDTypography>
                        </MDBox>
                        <Divider sx={{ mb: 1.5, borderBottomWidth: 2 }} />
                      </Grid>
                      {addressDetails.map((addr, index) => {
                        let addressType = addr.addresstype_c || addr.addresstype || `Address ${index + 1}`;
                        // Change "Current" to "Current Address" and "Permanent" to "Permanent Address"
                        if (addressType === 'Current') addressType = 'Current Address';
                        if (addressType === 'Permanent') addressType = 'Permanent Address';
                        
                        const address = decodeHTML(addr.address) || '';
                        const street = decodeHTML(addr.street) || '';
                        const village = decodeHTML(addr.village) || '';
                        const pincode = addr.pincode || '';
                        const taluk = decodeHTML(addr.taluk) || '';
                        const district = decodeHTML(addr.district) || '';
                        const state = decodeHTML(addr.state) || '';
                        const country = decodeHTML(addr.country) || '';
                        
                        // Use same purple color for all address headings
                        const headingColor = '#9c27b0';
                        
                        // Use full width for 2 or fewer items (Current & Permanent), otherwise use 5 columns
                        const gridSize = addressDetails.length <= 2 ? 12 / addressDetails.length : 2.4;
                        
                        return (
                          <Grid item xs={12} sm={addressDetails.length <= 2 ? 12 / addressDetails.length : 6} md={gridSize} key={index}>
                            <MDBox 
                              sx={{ 
                                p: 1.5, 
                                borderRadius: 1, 
                                bgcolor: 'grey.100',
                                border: '1px solid',
                                borderColor: 'grey.300',
                                height: '100%'
                              }}
                            >
                              <MDTypography variant="button" fontSize="0.9rem" fontWeight="bold" display="block" mb={0.5} sx={{ color: headingColor }}>
                                {addressType}
                              </MDTypography>
                              <MDTypography variant="body2" sx={{ wordBreak: 'break-word', color: 'text.secondary' }}>
                              {address && <>{address}</>}
                              {street && <><br/><strong>Street:</strong> {street}</>}
                              {village && <><br/><strong>Village/Town:</strong> {village}</>}
                              {pincode && <><br/><strong>Pincode:</strong> {pincode}</>}
                              {taluk && <><br/><strong>Taluk:</strong> {taluk}</>}
                              {district && <><br/><strong>District:</strong> {district}</>}
                              {state && <><br/><strong>State:</strong> {state}</>}
                              {country && <><br/><strong>Country:</strong> {country}</>}
                            </MDTypography>
                            </MDBox>
                          </Grid>
                        );
                      })}
                    </>
                  )}

                  {/* Education Details */}
                  {educationDetails && educationDetails.length > 0 && (
                    <>
                      <Grid item xs={12} mt={2}>
                        <MDBox display="flex" alignItems="center" mb={1}>
                          <Icon fontSize="medium" color="info" sx={{ mr: 1 }}>school</Icon>
                          <MDTypography variant="h5" fontWeight="bold" color="info">
                            Education ({educationDetails.length})
                          </MDTypography>
                        </MDBox>
                        <Divider sx={{ mb: 1.5, borderBottomWidth: 2 }} />
                      </Grid>
                      {educationDetails.map((edu, index) => {
                        // If qualification is "Others" (or "Other"), show others_c value, otherwise show qualification
                        const rawQual = (edu.qualification || "").toString().trim();
                        const isOthersQual = /^others?$/i.test(rawQual);
                        const qualification = isOthersQual && edu.others_c 
                          ? decodeHTML(edu.others_c) 
                          : decodeHTML(edu.qualification) || `Education ${index + 1}`;
                        const institute = decodeHTML(edu.institute || edu.instituteschool) || 'N/A';
                        const course = decodeHTML(edu.course);
                        const board = decodeHTML(edu.board);
                        const degreetype = decodeHTML(edu.degreetype);
                        const educationtype = decodeHTML(edu.educationtype);
                        const institutetype = decodeHTML(edu.institutetype);
                        const grade = decodeHTML(edu.grade);
                        const educationImage = typeof edu.image === 'string' && edu.image.startsWith('data:') ? edu.image : '';
                        
                        // Use full width for 3 or fewer items, otherwise use 5 columns
                        const gridSize = educationDetails.length <= 3 ? 12 / educationDetails.length : 2.4;
                        
                        return (
                          <Grid item xs={12} sm={educationDetails.length <= 3 ? 12 / educationDetails.length : 6} md={gridSize} key={index}>
                            <MDBox 
                              sx={{ 
                                p: 1.5, 
                                borderRadius: 1, 
                                bgcolor: 'grey.100',
                                border: '1px solid',
                                borderColor: 'grey.300',
                                height: '100%'
                              }}
                            >
                              <MDTypography variant="button" fontSize="0.9rem" color="info" fontWeight="bold" display="block" mb={0.5}>
                                {qualification}
                              </MDTypography>
                              <MDBox
                                display="flex"
                                flexDirection={{ xs: 'column', sm: 'row' }}
                                alignItems={{ xs: 'stretch', sm: 'flex-start' }}
                                sx={{ mt: 1, gap: 1.5 }}
                              >
                                {educationImage && (
                                  <Box
                                    component="img"
                                    src={educationImage}
                                    alt="Education ID"
                                    sx={{
                                      width: { xs: '100%', sm: 120 },
                                      maxHeight: 140,
                                      objectFit: 'contain',
                                      borderRadius: 1,
                                      border: '1px solid',
                                      borderColor: 'grey.300',
                                      backgroundColor: 'grey.50',
                                      boxShadow: 1,
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => openImagePreview(educationImage, `${qualification} Document`)}
                                    onError={(e) => {
                                      console.error('Failed to load education image:', educationImage);
                                      e.currentTarget.style.display = 'none';
                                    }}
                                  />
                                )}
                                <MDBox flex={1}>
                                  <MDTypography variant="body2" sx={{ wordBreak: 'break-word', color: 'text.secondary' }}>
                                    {institute}
                                    {course && <><br/><strong>Course:</strong> {course}</>}
                                    {edu.startyear_c && edu.endyear_c && (
                                      <><br/><strong>Duration:</strong> {edu.startyear_c} - {edu.currentlystudying_c === '1' ? 'Present' : edu.endyear_c}</>
                                    )}
                                    {edu.currentlystudying_c === '1' && <><br/><strong>Currently Studying</strong></>}
                                    {grade && <><br/><strong>Grade:</strong> {grade}</>}
                                    {board && <><br/><strong>Board:</strong> {board}</>}
                                    {degreetype && <><br/><strong>Degree Type:</strong> {degreetype}</>}
                                    {educationtype && <><br/><strong>Education Type:</strong> {educationtype}</>}
                                    {institutetype && <><br/><strong>Institute Type:</strong> {institutetype}</>}
                                    {edu.instituecity && edu.institutestate && <><br/><strong>Location:</strong> {decodeHTML(edu.instituecity)}, {decodeHTML(edu.institutestate)}</>}
                                    {edu.institutecountry && <><br/><strong>Country:</strong> {decodeHTML(edu.institutecountry)}</>}
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                            </MDBox>
                          </Grid>
                        );
                      })}
                    </>
                  )}

                  {/* Work Experience Details */}
                  {workDetails && workDetails.length > 0 && (
                    <>
                      <Grid item xs={12} mt={2}>
                        <MDBox display="flex" alignItems="center" mb={1}>
                          <Icon fontSize="medium" color="primary" sx={{ mr: 1 }}>work</Icon>
                          <MDTypography variant="h5" fontWeight="bold" color="primary">
                            Work Experience ({workDetails.length})
                          </MDTypography>
                        </MDBox>
                        <Divider sx={{ mb: 1.5, borderBottomWidth: 2 }} />
                      </Grid>
                      {workDetails.filter(w => w.companyname).map((work, index, filteredArray) => {
                        const designation = decodeHTML(work.designation) || 'Position';
                        const companyname = decodeHTML(work.companyname) || 'N/A';
                        const workImage = typeof work.image === 'string' && work.image.startsWith('data:') ? work.image : '';
                        
                        // Use full width for 3 or fewer items, otherwise use 5 columns
                        const gridSize = filteredArray.length <= 3 ? 12 / filteredArray.length : 2.4;
                        
                        return (
                          <Grid item xs={12} sm={filteredArray.length <= 3 ? 12 / filteredArray.length : 6} md={gridSize} key={index}>
                            <MDBox 
                              sx={{ 
                                p: 1.5, 
                                borderRadius: 1, 
                                bgcolor: 'grey.100',
                                border: '1px solid',
                                borderColor: 'grey.300',
                                height: '100%'
                              }}
                            >
                              <MDTypography variant="button" fontSize="0.9rem" color="primary" fontWeight="bold" display="block" mb={0.5}>
                                {designation}
                              </MDTypography>
                              <MDBox
                                display="flex"
                                flexDirection={{ xs: 'column', sm: 'row' }}
                                alignItems={{ xs: 'stretch', sm: 'flex-start' }}
                                sx={{ mt: 1, gap: 1.5 }}
                              >
                                {workImage && (
                                  <Box
                                    component="img"
                                    src={workImage}
                                    alt="Work Document"
                                    sx={{
                                      width: { xs: '100%', sm: 120 },
                                      maxHeight: 140,
                                      objectFit: 'contain',
                                      borderRadius: 1,
                                      border: '1px solid',
                                      borderColor: 'grey.300',
                                      backgroundColor: 'grey.50',
                                      boxShadow: 1,
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => openImagePreview(workImage, `${designation} Document`)}
                                    onError={(e) => {
                                      console.error('Failed to load work image:', workImage);
                                      e.currentTarget.style.display = 'none';
                                    }}
                                  />
                                )}
                                <MDBox flex={1}>
                                  <MDTypography variant="body2" sx={{ wordBreak: 'break-word', color: 'text.secondary' }}>
                                    {companyname}
                                    {work.startdate && work.enddate && <><br/><strong>Duration:</strong> {work.startdate} - {work.enddate}</>}
                                    {work.currentlyworking === '1' && <><br/><strong>Currently Working</strong></>}
                                    {work.employmenttype && <><br/><strong>Type:</strong> {decodeHTML(work.employmenttype)}</>}
                                    {work.sector && <><br/><strong>Sector:</strong> {decodeHTML(work.sector)}</>}
                                    {work.department && <><br/><strong>Dept:</strong> {decodeHTML(work.department)}</>}
                                    {work.city && work.state && <><br/><strong>Location:</strong> {decodeHTML(work.city)}, {decodeHTML(work.state)}</>}
                                    {work.description && <><br/><strong>Details:</strong> {decodeHTML(work.description).substring(0, 100)}{work.description.length > 100 ? '...' : ''}</>}
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                            </MDBox>
                          </Grid>
                        );
                      })}
                    </>
                  )}

                  {/* ID Cards Details */}
                  {idCardDetails && idCardDetails.length > 0 && (
                    <>
                      <Grid item xs={12} mt={2}>
                        <MDBox display="flex" alignItems="center" mb={1}>
                          <Icon fontSize="medium" color="warning" sx={{ mr: 1 }}>badge</Icon>
                          <MDTypography variant="h5" fontWeight="bold" color="warning">
                            ID Cards ({idCardDetails.length})
                          </MDTypography>
                        </MDBox>
                        <Divider sx={{ mb: 1.5, borderBottomWidth: 2 }} />
                      </Grid>
                      {idCardDetails.map((id, index) => {
                        const idtype = decodeHTML(id.idtype || id.idcardtype) || `ID Card ${index + 1}`;
                        const idnumber = id.idnumber || id.idcardnumber || 'N/A';
                        const issuedate = id.issuedate || id.issueddate_c || '';
                        const expirydate = id.expirydate || id.expirydate_c || '';
                        const idcardname = decodeHTML(id.name || id.idcardname);
                        const imageSlots = [
                          { src: id.image1, label: 'Front Page' },
                          { src: id.image2, label: 'Back Page' },
                          { src: id.image3, label: 'Additional Image 1' },
                          { src: id.image4, label: 'Additional Image 2' },
                        ].filter((slot) => typeof slot.src === 'string' && slot.src);
                        const primaryImages = imageSlots.slice(0, 2);
                        const extraImages = imageSlots.slice(2);
                        
                        // Use full width for 3 or fewer items, otherwise use 5 columns
                        const gridSize = idCardDetails.length <= 3 ? 12 / idCardDetails.length : 2.4;
                        
                        return (
                          <Grid item xs={12} sm={idCardDetails.length <= 3 ? 12 / idCardDetails.length : 6} md={gridSize} key={index}>
                            <MDBox 
                              sx={{ 
                                p: 1.5, 
                                borderRadius: 1, 
                                bgcolor: 'grey.100',
                                border: '1px solid',
                                borderColor: 'grey.300',
                                height: '100%'
                              }}
                            >
                              <MDTypography variant="button" fontSize="0.9rem" color="warning" fontWeight="bold" display="block" mb={0.5}>
                                {idtype}
                              </MDTypography>
                              
                              <MDBox
                                display="flex"
                                flexDirection={{ xs: 'column', sm: 'row' }}
                                alignItems={{ xs: 'stretch', sm: 'flex-start' }}
                                sx={{ mt: 1, gap: 1.5 }}
                              >
                                {primaryImages.length > 0 && (
                                  <MDBox
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 1,
                                      width: { xs: '100%', sm: 150 },
                                    }}
                                  >
                                    {primaryImages.map(({ src, label }, imageIndex) => (
                                      <MDBox key={`${label}-${imageIndex}`}>
                                        <MDTypography
                                          variant="caption"
                                          color="text.secondary"
                                          display="block"
                                          mb={0.5}
                                        >
                                          {label}
                                        </MDTypography>
                                        <Box
                                          component="img"
                                          src={src}
                                          alt={label}
                                          sx={{
                                            width: '100%',
                                            maxHeight: 120,
                                            objectFit: 'contain',
                                            borderRadius: 1,
                                            border: '1px solid',
                                            borderColor: 'grey.300',
                                            backgroundColor: 'grey.50',
                                            boxShadow: 1,
                                            cursor: 'pointer',
                                          }}
                                          onClick={() => openImagePreview(src, `${idtype} - ${label}`)}
                                          onError={(e) => {
                                            console.error(`Failed to load ${label}:`, src);
                                            e.currentTarget.style.display = 'none';
                                          }}
                                        />
                                      </MDBox>
                                    ))}
                                  </MDBox>
                                )}
                                <MDBox flex={1}>
                                  <MDTypography
                                    variant="body2"
                                    sx={{ wordBreak: 'break-word', color: 'text.secondary' }}
                                  >
                                    {idcardname && <>{idcardname}<br/></>}
                                    <strong>Number:</strong> {idnumber}
                                    {issuedate && <><br/><strong>Issued:</strong> {issuedate}</>}
                                    {expirydate && <><br/><strong>Expires:</strong> {expirydate}</>}
                                    {id.description && <><br/><strong>Note:</strong> {decodeHTML(id.description)}</>}
                                  </MDTypography>
                                  {extraImages.length > 0 && (
                                    <MDBox sx={{ mt: 1.5, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                      {extraImages.map(({ src, label }, extraIndex) => (
                                        <MDBox key={`${label}-extra-${extraIndex}`} sx={{ width: 120 }}>
                                          <MDTypography
                                            variant="caption"
                                            color="text.secondary"
                                            display="block"
                                            mb={0.5}
                                          >
                                            {label}
                                          </MDTypography>
                                          <Box
                                            component="img"
                                            src={src}
                                            alt={label}
                                            sx={{
                                              width: '100%',
                                              maxHeight: 100,
                                              objectFit: 'contain',
                                              borderRadius: 1,
                                              border: '1px solid',
                                              borderColor: 'grey.300',
                                              backgroundColor: 'grey.50',
                                              boxShadow: 1,
                                              cursor: 'pointer',
                                            }}
                                            onClick={() => openImagePreview(src, `${idtype} - ${label}`)}
                                            onError={(e) => {
                                              console.error(`Failed to load ${label}:`, src);
                                              e.currentTarget.style.display = 'none';
                                            }}
                                          />
                                        </MDBox>
                                      ))}
                                    </MDBox>
                                  )}
                                </MDBox>
                              </MDBox>
                            </MDBox>
                          </Grid>
                        );
                      })}
                    </>
                  )}

                  {/* Bank Details */}
                  {bankDetails && bankDetails.length > 0 && (
                    <>
                      <Grid item xs={12} mt={2}>
                        <MDBox display="flex" alignItems="center" mb={1}>
                          <Icon fontSize="medium" color="success" sx={{ mr: 1 }}>account_balance</Icon>
                          <MDTypography variant="h5" fontWeight="bold" color="success">
                            Bank Accounts ({bankDetails.length})
                          </MDTypography>
                        </MDBox>
                        <Divider sx={{ mb: 1.5, borderBottomWidth: 2 }} />
                      </Grid>
                      {bankDetails.map((bank, index) => {
                        const bankname = decodeHTML(bank.bankname) || `Bank ${index + 1}`;
                        const passbookImage = typeof bank.image === 'string' && bank.image.startsWith('data:') ? bank.image : '';
                        
                        // Use full width for 3 or fewer items, otherwise use 5 columns
                        const gridSize = bankDetails.length <= 3 ? 12 / bankDetails.length : 2.4;
                        
                        return (
                          <Grid item xs={12} sm={bankDetails.length <= 3 ? 12 / bankDetails.length : 6} md={gridSize} key={index}>
                            <MDBox 
                              sx={{ 
                                p: 1.5, 
                                borderRadius: 1, 
                                bgcolor: 'grey.100',
                                border: '1px solid',
                                borderColor: 'grey.300',
                                height: '100%'
                              }}
                            >
                              <MDTypography variant="button" fontSize="0.9rem" color="success" fontWeight="bold" display="block" mb={0.5}>
                                {bankname}
                              </MDTypography>
                              <MDBox
                                display="flex"
                                flexDirection={{ xs: 'column', sm: 'row' }}
                                alignItems={{ xs: 'stretch', sm: 'flex-start' }}
                                sx={{ mt: 1, gap: 1.5 }}
                              >
                                {passbookImage && (
                                  <Box
                                    component="img"
                                    src={passbookImage}
                                    alt="Passbook"
                                    sx={{
                                      width: { xs: '100%', sm: 120 },
                                      maxHeight: 140,
                                      objectFit: 'contain',
                                      borderRadius: 1,
                                      border: '1px solid',
                                      borderColor: 'grey.300',
                                      backgroundColor: 'grey.50',
                                      boxShadow: 1,
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => openImagePreview(passbookImage, `${bankname} Passbook`)}
                                    onError={(e) => {
                                      console.error('Failed to load bank image:', passbookImage);
                                      e.currentTarget.style.display = 'none';
                                    }}
                                  />
                                )}
                                <MDBox flex={1}>
                                  <MDTypography variant="body2" sx={{ wordBreak: 'break-word', color: 'text.secondary' }}>
                                    {bank.accountholdername && <>{decodeHTML(bank.accountholdername)}<br/></>}
                                    <strong>A/c No:</strong> {bank.accountnumber || 'N/A'}
                                    {bank.ifsccode && <><br/><strong>IFSC:</strong> {bank.ifsccode}</>}
                                    {bank.accounttype && <><br/><strong>Type:</strong> {decodeHTML(bank.accounttype)}</>}
                                    {bank.branchname && <><br/><strong>Branch:</strong> {decodeHTML(bank.branchname)}</>}
                                    {bank.branchaddress && <><br/><strong>Address:</strong> {decodeHTML(bank.branchaddress)}</>}
                                    {bank.micrcode && <><br/><strong>MICR:</strong> {bank.micrcode}</>}
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                            </MDBox>
                          </Grid>
                        );
                      })}
                    </>
                  )}

                  {/* Social Links Details */}
                  {socialLinksDetails && socialLinksDetails.length > 0 && (
                    <>
                      <Grid item xs={12} mt={2}>
                        <MDBox display="flex" alignItems="center" mb={1}>
                          <Icon fontSize="medium" color="secondary" sx={{ mr: 1 }}>share</Icon>
                          <MDTypography variant="h5" fontWeight="bold" color="secondary">
                            Social Links ({socialLinksDetails.length})
                          </MDTypography>
                        </MDBox>
                        <Divider sx={{ mb: 1.5, borderBottomWidth: 2 }} />
                      </Grid>
                      {socialLinksDetails.map((social, index) => {
                        const { platform, linkUrl } = getSocialPlatformConfig(social);
                        
                        // Use full width for 3 or fewer items, otherwise use 5 columns
                        const gridSize = socialLinksDetails.length <= 3 ? 12 / socialLinksDetails.length : 2.4;
                        
                        return (
                          <Grid item xs={12} sm={socialLinksDetails.length <= 3 ? 12 / socialLinksDetails.length : 6} md={gridSize} key={index}>
                            <a
                              href={linkUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ textDecoration: "none" }}
                            >
                              <MDBox
                                textAlign="center"
                                p={2}
                                borderRadius="lg"
                                sx={{
                                  bgcolor: "#f5f5f5",
                                  cursor: "pointer",
                                  transition: "all 0.3s",
                                  height: '100%',
                                  "&:hover": {
                                    bgcolor: platform.color,
                                    transform: "translateY(-5px)",
                                    boxShadow: 3,
                                    "& .MuiIcon-root, & .MuiTypography-root": {
                                      color: platform.textColor || "white !important",
                                    },
                                  },
                                }}
                              >
                                <Icon fontSize="large" sx={{ color: platform.color }}>
                                  {platform.icon}
                                </Icon>
                                <MDTypography variant="button" display="block" mt={1}>
                                  {platform.displayName}
                                </MDTypography>
                                <MDTypography variant="caption" sx={{ wordBreak: "break-all" }}>
                                  {decodeHTML(social.link)}
                                </MDTypography>
                              </MDBox>
                            </a>
                          </Grid>
                        );
                      })}
                    </>
                  )}
                </Grid>
              </MDBox>
            </Card>
          )}

          {/* Detailed View */}
          {viewMode === 'detailed' && (
            <Grid container spacing={3}>
            {/* Basic Information Card */}
            <Grid item xs={12} md={6} lg={4}>
              <Card sx={{ height: "100%", boxShadow: 3 }}>
                <MDBox p={3}>
                  <MDBox display="flex" alignItems="center" mb={3}>
                    <Icon fontSize="large" color="info">
                      person
                    </Icon>
                    <MDTypography variant="h5" fontWeight="bold" ml={1}>
                      Basic Information
                    </MDTypography>
                  </MDBox>
                  <InfoRow icon="email" label="Email" value={profile.email_c?.value} />
                  <InfoRow icon="phone" label="Mobile" value={profile.phone_mobile?.value} />
                  <InfoRow icon="cake" label="Date of Birth" value={profile.dob_c?.value} />
                  <InfoRow icon="event" label="Age" value={profile.age_c?.value} />
                  <InfoRow icon="wc" label="Gender" value={profile.gender_c?.value} />
                  <InfoRow
                    icon="favorite"
                    label="Blood Group"
                    value={profile.bloodgroup_c?.value}
                  />
                  <InfoRow icon="place" label="Birth Place" value={profile.birthplace_c?.value} />
                  <InfoRow icon="badge" label="Aadhaar" value={profile.aadhaar_c?.value} />
                </MDBox>
              </Card>
            </Grid>

            {/* Personal Details Card */}
            <Grid item xs={12} md={6} lg={4}>
              <Card sx={{ height: "100%", boxShadow: 3 }}>
                <MDBox p={3}>
                  <MDBox display="flex" alignItems="center" mb={3}>
                    <Icon fontSize="large" color="warning">
                      info
                    </Icon>
                    <MDTypography variant="h5" fontWeight="bold" ml={1}>
                      Personal Details
                    </MDTypography>
                  </MDBox>
                  <InfoRow icon="groups" label="Caste" value={profile.caste_c?.value} />
                  <InfoRow icon="temple_hindu" label="Religion" value={profile.religion_c?.value} />
                  <InfoRow
                    icon="accessible"
                    label="Disability"
                    value={profile.disability_c?.value}
                  />
                  {profile.disability_c?.value === "Yes" && (
                    <InfoRow
                      icon="healing"
                      label="Disability Type"
                      value={profile.disabilitytype_c?.value}
                    />
                  )}
                   <InfoRow
                    icon="account_balance_wallet"
                    label="Economic Status"
                    value={profile.economical_status_c?.value}
                  />
                  <InfoRow
                    icon="health_and_safety"
                    label="Alive Status"
                    value={profile.alivestatus_c?.value}
                  />
                  {profile.alivestatus_c?.value?.includes("Deceased") && (
                    <>
                      <InfoRow
                        icon="event"
                        label="Date of Death"
                        value={profile.dateofdeath_c?.value}
                      />
                      <InfoRow
                        icon="location_on"
                        label="Death Place"
                        value={profile.deathplace_c?.value}
                      />
                      <InfoRow
                        icon="info"
                        label="Death Reason"
                        value={profile.deathreason_c?.value}
                      />
                      <InfoRow
                        icon="home"
                        label="Death Address"
                        value={profile.deathaddress_c?.value}
                      />
                      <InfoRow icon="map" label="Death Area" value={profile.deatharea_c?.value} />
                      <InfoRow
                        icon="pin_drop"
                        label="Death Pincode"
                        value={profile.deathpincode_c?.value}
                      />
                      <InfoRow
                        icon="location_city"
                        label="Death City"
                        value={profile.deathcity_c?.value}
                      />
                      <InfoRow
                        icon="flag"
                        label="Death State"
                        value={profile.deathstate_c?.value}
                      />
                      <InfoRow
                        icon="public"
                        label="Death Country"
                        value={profile.deathcountry_c?.value}
                      />
                    </>
                  )}
                  <InfoRow
                    icon="person_add"
                    label="Referred By"
                    value={profile.referrer_c?.value}
                  />
                </MDBox>
              </Card>
            </Grid>

            {/* Other Details Card */}
            <Grid item xs={12} md={6} lg={4}>
              <Card sx={{ height: "100%", boxShadow: 3 }}>
                <MDBox p={3}>
                  <MDBox display="flex" alignItems="center" mb={3}>
                    <Icon fontSize="large" color="error">
                      info_outline
                    </Icon>
                    <MDTypography variant="h5" fontWeight="bold" ml={1}>
                      Other Details
                    </MDTypography>
                  </MDBox>
                  
                  {/* Language Details Section */}
                  <MDTypography variant="subtitle2" fontWeight="bold" color="text" mt={1} mb={1}>
                    Language Details
                  </MDTypography>
                  <InfoRow
                    icon="record_voice_over"
                    label="Mother Tongue"
                    value={profile.mothertongue_c?.value}
                  />
                  <InfoRow
                    icon="translate"
                    label="Languages Known"
                    value={profile.languagesknown_c?.value}
                  />
                  
                  {/* Marital Details Section */}
                  <MDTypography variant="subtitle2" fontWeight="bold" color="text" mt={3} mb={1}>
                    Marital Details
                  </MDTypography>
                  <InfoRow
                    icon="family_restroom"
                    label="Marital Status"
                    value={profile.maritalstatus_c?.value}
                  />
                  {profile.maritalstatus_c?.value === "Married" && (
                    <>
                      <InfoRow
                        icon="event"
                        label="Marriage Date"
                        value={profile.marriagedate_c?.value}
                      />
                      <InfoRow
                        icon="church"
                        label="Marriage Place"
                        value={profile.marriageplace_c?.value}
                      />
                    </>
                  )}
                </MDBox>
              </Card>
            </Grid>

            {/* Passkeys Section - Full Width */}
            <Grid item xs={12}>
              <Card sx={{ boxShadow: 3 }}>
                <MDBox p={3}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={3}>
                    <MDBox display="flex" alignItems="center">
                      <Icon fontSize="large" color="info">
                        vpn_key
                      </Icon>
                      <MDTypography variant="h5" fontWeight="bold" ml={1}>
                        Passkeys
                      </MDTypography>
                    </MDBox>
                    <MDButton
                      variant="gradient"
                      color="info"
                      size="small"
                      onClick={() => setAddPasskeyDialogOpen(true)}
                      startIcon={<Icon>add</Icon>}
                      sx={{ color: "white !important" }}
                    >
                      Add Passkey
                    </MDButton>
                  </MDBox>
                  <Grid container spacing={2}>
                    {(() => {
                      const passkeyEntries = passkeyDetails && passkeyDetails.length > 0 ? passkeyDetails : [];

                      // Filter out empty entries
                      const validPasskeyEntries = passkeyEntries.filter((entry) => {
                        if (!entry) return false;
                        const hasData =
                          (entry.type && entry.type.trim()) ||
                          (entry.name && entry.name.trim());
                        return hasData;
                      });

                      const totalPasskeys = validPasskeyEntries.length;

                      if (totalPasskeys === 0) {
                        return (
                          <Grid item xs={12}>
                            <MDBox textAlign="center" py={3}>
                              <MDTypography variant="body2" color="text">
                                No passkeys available
                              </MDTypography>
                            </MDBox>
                          </Grid>
                        );
                      }

                      // If 1-3 entries, show all in one row; otherwise use 3-column layout
                      const gridSize = totalPasskeys <= 3 ? 12 / totalPasskeys : 4;

                      return validPasskeyEntries.map((entry, index) => {
                        const passkeyId = entry.id || `passkey-${index}`;
                        const isVisible = visiblePasskeys[passkeyId] || false;

                        return (
                        <Grid
                          item
                          xs={12}
                          md={totalPasskeys <= 3 ? gridSize : 6}
                          lg={totalPasskeys <= 3 ? gridSize : 4}
                          key={passkeyId}
                        >
                          <Card 
                            sx={{ 
                              p: 2,
                              mb: 2,
                              boxShadow: 2,
                              height: "100%", 
                              display: "flex", 
                              flexDirection: "column",
                              position: "relative"
                            }}
                          >
                            {/* Action Icons */}
                            <MDBox
                              sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                display: "flex",
                                gap: 1,
                                zIndex: 1,
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={() => setEditingPasskeyEntry(entry)}
                                sx={{ color: "info.main" }}
                              >
                                <Icon fontSize="small">edit</Icon>
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setPasskeyToDelete(entry);
                                  setDeletePasskeyConfirmOpen(true);
                                }}
                                sx={{ color: "error.main" }}
                              >
                                <Icon fontSize="small">delete</Icon>
                              </IconButton>
                            </MDBox>

                            {/* Card Content */}
                            <MDBox flex={1}>
                              <MDBox display="flex" alignItems="center" mb={2} pr={6}>
                                <Icon fontSize="medium" color="info" sx={{ mr: 1 }}>
                                  vpn_key
                                </Icon>
                                <MDTypography variant="h6" fontWeight="medium">
                                  {entry.type || "Passkey"}
                                </MDTypography>
                              </MDBox>
                              <Divider />
                              <MDBox mt={2}>
                                <MDBox display="flex" alignItems="center" mb={1}>
                                  <Icon fontSize="small" sx={{ mr: 1 }}>
                                    person
                                  </Icon>
                                  <MDTypography variant="body2" fontWeight="bold">
                                    Name/Username:
                                  </MDTypography>
                                </MDBox>
                                <MDTypography variant="body2" color="text" ml={3.5}>
                                  {entry.name || "N/A"}
                                </MDTypography>
                                {entry.description && (
                                  <>
                                    <MDBox display="flex" alignItems="center" mt={2} mb={1}>
                                      <Icon fontSize="small" sx={{ mr: 1 }}>
                                        description
                                      </Icon>
                                      <MDTypography variant="body2" fontWeight="bold">
                                        Description:
                                      </MDTypography>
                                    </MDBox>
                                    <MDTypography variant="body2" color="text" ml={3.5}>
                                      {entry.description}
                                    </MDTypography>
                                  </>
                                )}
                                <MDBox display="flex" alignItems="center" mt={2} mb={1}>
                                  <Icon fontSize="small" sx={{ mr: 1 }}>
                                    lock
                                  </Icon>
                                  <MDTypography variant="body2" fontWeight="bold">
                                    PIN/Password:
                                  </MDTypography>
                                  <IconButton
                                    size="small"
                                    onClick={() => togglePasskeyVisibility(passkeyId)}
                                    sx={{ ml: 1 }}
                                  >
                                    <Icon fontSize="small">
                                      {isVisible ? "visibility" : "visibility_off"}
                                    </Icon>
                                  </IconButton>
                                </MDBox>
                                <MDTypography variant="body2" color="text" ml={3.5}>
                                  {isVisible ? (entry.pin || "N/A") : "••••••••••"}
                                </MDTypography>
                              </MDBox>
                            </MDBox>
                          </Card>
                        </Grid>
                      );
                      });
                    })()}
                  </Grid>
                </MDBox>
              </Card>
            </Grid>

            {/* Address Section - Full Width */}
            <Grid item xs={12}>
              <Card sx={{ boxShadow: 3 }}>
                <MDBox p={3}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={3}>
                    <MDBox display="flex" alignItems="center">
                      <Icon fontSize="large" sx={{ color: '#9c27b0' }}>
                        home
                      </Icon>
                      <MDTypography variant="h5" fontWeight="bold" ml={1}>
                        Address Details
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <Grid container spacing={2}>
                    {(() => {
                      const addressEntries = addressDetails && addressDetails.length > 0 ? addressDetails : [];

                      // Filter out empty entries
                      const validAddressEntries = addressEntries.filter((entry) => {
                        if (!entry) return false;
                        const hasData =
                          (entry.address && entry.address.trim()) ||
                          (entry.street && entry.street.trim()) ||
                          (entry.village && entry.village.trim()) ||
                          (entry.pincode && entry.pincode.trim()) ||
                          (entry.taluk && entry.taluk.trim()) ||
                          (entry.district && entry.district.trim()) ||
                          (entry.state && entry.state.trim()) ||
                          (entry.country && entry.country.trim());
                        return hasData;
                      });

                      const totalAddresses = validAddressEntries.length;

                      if (totalAddresses === 0) {
                        return (
                          <Grid item xs={12}>
                            <MDBox textAlign="center" py={3}>
                              <MDTypography variant="body2" color="text">
                                No address details available
                              </MDTypography>
                            </MDBox>
                          </Grid>
                        );
                      }

                      // If 1-2 entries (Current & Permanent), show in one row; otherwise use 3-column layout
                      const gridSize = totalAddresses <= 2 ? 12 / totalAddresses : 4;

                      return validAddressEntries.map((entry, index) => (
                        <Grid
                          item
                          xs={12}
                          md={totalAddresses <= 2 ? gridSize : 6}
                          lg={totalAddresses <= 2 ? gridSize : 4}
                          key={entry.id || `address-${index}`}
                        >
                          {renderAddressDetail(entry, index)}
                        </Grid>
                      ));
                    })()}
                  </Grid>
                </MDBox>
              </Card>
            </Grid>

            {/* Education Section - Full Width */}
            <Grid item xs={12}>
              <Card sx={{ boxShadow: 3 }}>
                <MDBox p={3}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={3}>
                    <MDBox display="flex" alignItems="center">
                      <Icon fontSize="large" color="info">
                        school
                      </Icon>
                      <MDTypography variant="h5" fontWeight="bold" ml={1}>
                        Education Details
                      </MDTypography>
                    </MDBox>
                    <MDButton
                      variant="gradient"
                      color="info"
                      size="small"
                      onClick={() => setAddEducationDialogOpen(true)}
                    >
                      <Icon sx={{ mr: 0.5 }}>add</Icon>
                      Add Education
                    </MDButton>
                  </MDBox>
                  <Grid container spacing={2}>
                    {(() => {
                      const educationEntries =
                        educationDetails && educationDetails.length > 0
                          ? educationDetails
                          : [1, 2, 3, 4, 5]
                              .map((num) => {
                                const edu = decodeHTMLEntities(profile[`education${num}_c`]?.value);
                                const degree = profile[`degree${num}_c`]?.value;
                                const course = profile[`course${num}_c`]?.value;
                                const type = profile[`educationtype${num}_c`]?.value;
                                const institute = profile[`institute${num}_c`]?.value;
                                const year = profile[`yearofpassing${num}_c`]?.value;

                                if (!edu && !type && !institute && !year && !degree && !course)
                                  return null;

                                return {
                                  type: "education",
                                  qualification: edu,
                                  degree,
                                  course,
                                  educationtype: type,
                                  institute,
                                  yearofpassing: year,
                                  index: num,
                                };
                              })
                              .filter(Boolean);

                      const totalEducation = educationEntries.length;

                      if (totalEducation === 0) {
                        return (
                          <Grid item xs={12}>
                            <MDBox textAlign="center" py={3}>
                              <MDTypography variant="body2" color="text">
                                No education details available
                              </MDTypography>
                            </MDBox>
                          </Grid>
                        );
                      }

                      // If 1-3 entries, show all in one row; otherwise use 3-column layout
                      const gridSize = totalEducation <= 3 ? 12 / totalEducation : 4;

                      return educationEntries.map((entry, index) => (
                        <Grid
                          item
                          xs={12}
                          md={totalEducation <= 3 ? gridSize : 6}
                          lg={totalEducation <= 3 ? gridSize : 4}
                          key={entry.id || `education-${index}`}
                        >
                          {renderEducationDetail(entry, index)}
                        </Grid>
                      ));
                    })()}
                  </Grid>
                </MDBox>
              </Card>
            </Grid>

            {/* Work Experience Section - Full Width */}
            <Grid item xs={12}>
              <Card sx={{ boxShadow: 3 }}>
                <MDBox p={3}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={3}>
                    <MDBox display="flex" alignItems="center">
                      <Icon fontSize="large" color="primary">
                        work
                      </Icon>
                      <MDTypography variant="h5" fontWeight="bold" ml={1}>
                        Work Experience
                      </MDTypography>
                    </MDBox>
                    <MDButton
                      variant="gradient"
                      color="primary"
                      size="small"
                      onClick={() => setAddWorkDialogOpen(true)}
                    >
                      <Icon sx={{ mr: 0.5 }}>add</Icon>
                      Add Work Experience
                    </MDButton>
                  </MDBox>
                  <Grid container spacing={2}>
                    {(() => {
                      const workEntries = workDetails && workDetails.length > 0 ? workDetails : [];

                      // Filter out empty entries (entries with no meaningful data)
                      const validWorkEntries = workEntries.filter((entry) => {
                        if (!entry) return false;
                        const hasData =
                          (entry.companyname && entry.companyname.trim()) ||
                          (entry.designation && entry.designation.trim()) ||
                          (entry.department && entry.department.trim()) ||
                          (entry.sector && entry.sector.trim()) ||
                          (entry.employmenttype && entry.employmenttype.trim()) ||
                          (entry.startdate && entry.startdate.trim()) ||
                          (entry.enddate && entry.enddate.trim()) ||
                          (entry.city && entry.city.trim()) ||
                          (entry.state && entry.state.trim()) ||
                          (entry.country && entry.country.trim()) ||
                          (entry.address && entry.address.trim()) ||
                          (entry.description && entry.description.trim());
                        return hasData;
                      });

                      const totalWork = validWorkEntries.length;

                      if (totalWork === 0) {
                        return (
                          <Grid item xs={12}>
                            <MDBox textAlign="center" py={3}>
                              <MDTypography variant="body2" color="text">
                                No work experience available
                              </MDTypography>
                            </MDBox>
                          </Grid>
                        );
                      }

                      // If 1-3 entries, show all in one row; otherwise use 3-column layout
                      const gridSize = totalWork <= 3 ? 12 / totalWork : 4;

                      return validWorkEntries.map((entry, index) => (
                        <Grid
                          item
                          xs={12}
                          md={totalWork <= 3 ? gridSize : 6}
                          lg={totalWork <= 3 ? gridSize : 4}
                          key={entry.id || `work-${index}`}
                        >
                          {renderWorkDetail(entry, index)}
                        </Grid>
                      ));
                    })()}
                  </Grid>
                </MDBox>
              </Card>
            </Grid>

            {/* ID Card Details Section - Full Width */}
            <Grid item xs={12}>
              <Card sx={{ boxShadow: 3 }}>
                <MDBox p={3}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={3}>
                    <MDBox display="flex" alignItems="center">
                      <Icon fontSize="large" color="warning">
                        badge
                      </Icon>
                      <MDTypography variant="h5" fontWeight="bold" ml={1}>
                        ID Card Details
                      </MDTypography>
                    </MDBox>
                    <MDButton
                      variant="gradient"
                      color="warning"
                      size="small"
                      onClick={() => setAddIDCardDialogOpen(true)}
                      startIcon={<Icon>add</Icon>}
                    >
                      Add ID Card
                    </MDButton>
                  </MDBox>
                  <Grid container spacing={2}>
                    {(() => {
                      const idCardEntries = idCardDetails && idCardDetails.length > 0 ? idCardDetails : [];

                      // Filter out empty entries (entries with no meaningful data)
                      const validIDCardEntries = idCardEntries.filter((entry) => {
                        if (!entry) return false;
                        const hasData =
                          (entry.idtype && entry.idtype.trim()) ||
                          (entry.name && entry.name.trim()) ||
                          (entry.idnumber && entry.idnumber.trim()) ||
                          (entry.issuedate && entry.issuedate.trim()) ||
                          (entry.expirydate && entry.expirydate.trim()) ||
                          (entry.description && entry.description.trim());
                        return hasData;
                      });

                      const totalIDCards = validIDCardEntries.length;

                      if (totalIDCards === 0) {
                        return (
                          <Grid item xs={12}>
                            <MDBox textAlign="center" py={3}>
                              <MDTypography variant="body2" color="text">
                                No ID card details available
                              </MDTypography>
                            </MDBox>
                          </Grid>
                        );
                      }

                      // If 1-3 entries, show all in one row; otherwise use 3-column layout
                      const gridSize = totalIDCards <= 3 ? 12 / totalIDCards : 4;

                      return validIDCardEntries.map((entry, index) => (
                        <Grid
                          item
                          xs={12}
                          md={totalIDCards <= 3 ? gridSize : 6}
                          lg={totalIDCards <= 3 ? gridSize : 4}
                          key={entry.id || `idcard-${index}`}
                        >
                          {renderIDCardDetail(entry, index)}
                        </Grid>
                      ));
                    })()}
                  </Grid>
                </MDBox>
              </Card>
            </Grid>

            {/* Bank Details Section - Full Width */}
            <Grid item xs={12}>
              <Card sx={{ boxShadow: 3 }}>
                <MDBox p={3}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={3}>
                    <MDBox display="flex" alignItems="center">
                      <Icon fontSize="large" color="success">
                        account_balance
                      </Icon>
                      <MDTypography variant="h5" fontWeight="bold" ml={1}>
                        Bank Details
                      </MDTypography>
                    </MDBox>
                    <MDButton
                      variant="gradient"
                      color="success"
                      size="small"
                      onClick={() => setAddBankDialogOpen(true)}
                      startIcon={<Icon>add</Icon>}
                    >
                      Add Bank Account
                    </MDButton>
                  </MDBox>
                  <Grid container spacing={2}>
                    {(() => {
                      const bankEntries = bankDetails && bankDetails.length > 0 ? bankDetails : [];

                      // Filter out empty entries (entries with no meaningful data)
                      const validBankEntries = bankEntries.filter((entry) => {
                        if (!entry) return false;
                        const hasData =
                          (entry.accountholdername && entry.accountholdername.trim()) ||
                          (entry.accountnumber && entry.accountnumber.trim()) ||
                          (entry.ifsc && entry.ifsc.trim()) ||
                          (entry.bankname && entry.bankname.trim()) ||
                          (entry.accounttype && entry.accounttype.trim()) ||
                          (entry.branch && entry.branch.trim()) ||
                          (entry.bankcountry && entry.bankcountry.trim()) ||
                          (entry.status && entry.status.trim()) ||
                          (entry.description && entry.description.trim());
                        return hasData;
                      });

                      const totalBankAccounts = validBankEntries.length;

                      if (totalBankAccounts === 0) {
                        return (
                          <Grid item xs={12}>
                            <MDBox textAlign="center" py={3}>
                              <MDTypography variant="body2" color="text">
                                No bank details available
                              </MDTypography>
                            </MDBox>
                          </Grid>
                        );
                      }

                      // If 1-3 entries, show all in one row; otherwise use 3-column layout
                      const gridSize = totalBankAccounts <= 3 ? 12 / totalBankAccounts : 4;

                      return validBankEntries.map((entry, index) => (
                        <Grid
                          item
                          xs={12}
                          md={totalBankAccounts <= 3 ? gridSize : 6}
                          lg={totalBankAccounts <= 3 ? gridSize : 4}
                          key={entry.id || `bank-${index}`}
                        >
                          {renderBankDetail(entry, index)}
                        </Grid>
                      ));
                    })()}
                  </Grid>
                </MDBox>
              </Card>
            </Grid>

            {/* Delete ID Card Confirmation Dialog */}
            <DeleteIDCardDialog
              open={deleteIDCardConfirmOpen}
              onClose={() => {
                setDeleteIDCardConfirmOpen(false);
                setIdCardToDelete(null);
              }}
              idCardEntry={idCardToDelete}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onIDCardDeleted={(updatedList) => setIDCardDetails(updatedList)}
            />

            {/* Edit ID Card Dialog */}
            <EditIDCardDialog
              open={editingIDCardEntry !== null}
              onClose={() => setEditingIDCardEntry(null)}
              idCardEntry={editingIDCardEntry}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onIDCardUpdated={(updatedList) => setIDCardDetails(updatedList)}
            />

            {/* Add ID Card Dialog */}
            <AddIDCardDialog
              open={addIDCardDialogOpen}
              onClose={() => setAddIDCardDialogOpen(false)}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onIDCardAdded={(updatedList) => setIDCardDetails(updatedList)}
            />

            {/* Delete Bank Confirmation Dialog */}
            <DeleteBankDialog
              open={deleteConfirmOpen}
              onClose={() => {
                setDeleteConfirmOpen(false);
                setBankToDelete(null);
              }}
              bankEntry={bankToDelete}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onBankDeleted={(updatedList) => setBankDetails(updatedList)}
            />

            {/* Edit Bank Dialog */}
            <EditBankDialog
              open={editingBankEntry !== null}
              onClose={() => setEditingBankEntry(null)}
              bankEntry={editingBankEntry}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onBankUpdated={(updatedList) => setBankDetails(updatedList)}
            />

            {/* Delete Education Dialog */}
            <DeleteEducationDialog
              open={deleteEducationConfirmOpen}
              onClose={() => {
                setDeleteEducationConfirmOpen(false);
                setEducationToDelete(null);
              }}
              educationEntry={educationToDelete}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onEducationDeleted={(updatedList) => setEducationDetails(updatedList)}
            />

            {/* Edit Education Dialog */}
            <EditEducationDialog
              open={editingEducationEntry !== null}
              onClose={() => setEditingEducationEntry(null)}
              educationEntry={editingEducationEntry}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onEducationUpdated={(updatedList) => setEducationDetails(updatedList)}
            />

            {/* Add Education Dialog */}
            <AddEducationDialog
              open={addEducationDialogOpen}
              onClose={() => setAddEducationDialogOpen(false)}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onEducationAdded={(updatedList) => setEducationDetails(updatedList)}
            />

            {/* Delete Work Experience Dialog */}
            <DeleteWorkExperienceDialog
              open={deleteWorkConfirmOpen}
              onClose={() => {
                setDeleteWorkConfirmOpen(false);
                setWorkToDelete(null);
              }}
              workEntry={workToDelete}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onWorkDeleted={(updatedList) => setWorkDetails(updatedList)}
            />

            {/* Edit Work Experience Dialog */}
            <EditWorkExperienceDialog
              open={editingWorkEntry !== null}
              onClose={() => setEditingWorkEntry(null)}
              workEntry={editingWorkEntry}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onWorkUpdated={(updatedList) => setWorkDetails(updatedList)}
            />

            {/* Add Work Experience Dialog */}
            <AddWorkExperienceDialog
              open={addWorkDialogOpen}
              onClose={() => setAddWorkDialogOpen(false)}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onWorkAdded={(updatedList) => setWorkDetails(updatedList)}
            />

            {/* Add Bank Dialog */}
            <AddBankDialog
              open={addBankDialogOpen}
              onClose={() => setAddBankDialogOpen(false)}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onBankAdded={(updatedList) => setBankDetails(updatedList)}
            />

            {/* Social Links Section - Dynamic from Database */}
            <Grid item xs={12}>
              <Card sx={{ boxShadow: 3 }}>
                <MDBox p={3}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={3}>
                    <MDBox display="flex" alignItems="center">
                      <Icon fontSize="large" sx={{ color: "#9C27B0" }}>
                        share
                      </Icon>
                      <MDTypography variant="h5" fontWeight="bold" ml={1}>
                        Social Media
                      </MDTypography>
                    </MDBox>
                    <MDButton
                      variant="gradient"
                      sx={{ 
                        background: "linear-gradient(195deg, #9C27B0, #7B1FA2)",
                        color: "white !important",
                        "& .MuiIcon-root": {
                          color: "white !important"
                        }
                      }}
                      size="small"
                      onClick={() => setAddSocialLinkDialogOpen(true)}
                      startIcon={<Icon>add</Icon>}
                    >
                      Add Social Link
                    </MDButton>
                  </MDBox>
                  <Grid container spacing={3}>
                    {(() => {
                      const socialEntries = socialLinksDetails && socialLinksDetails.length > 0 ? socialLinksDetails : [];

                      // Filter out empty entries
                      const validSocialEntries = socialEntries.filter((entry) => {
                        if (!entry) return false;
                        const hasData =
                          (entry.type && entry.type.trim()) ||
                          (entry.link && entry.link.trim());
                        return hasData;
                      });

                      if (validSocialEntries.length === 0) {
                        return (
                          <Grid item xs={12}>
                            <MDBox textAlign="center" py={3}>
                              <MDTypography variant="body2" color="text">
                                No social media links available
                              </MDTypography>
                            </MDBox>
                          </Grid>
                        );
                      }

                      return validSocialEntries.map((entry, index) => renderSocialLink(entry, index));
                    })()}
                  </Grid>
                </MDBox>
              </Card>
            </Grid>

            {/* Delete Social Link Confirmation Dialog */}
            <DeleteSocialLinkDialog
              open={deleteSocialLinkConfirmOpen}
              onClose={() => {
                setDeleteSocialLinkConfirmOpen(false);
                setSocialLinkToDelete(null);
              }}
              socialLinkEntry={socialLinkToDelete}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onSocialLinkDeleted={(updatedList) => setSocialLinksDetails(updatedList)}
            />

            {/* Edit Social Link Dialog */}
            <EditSocialLinkDialog
              open={editingSocialLinkEntry !== null}
              onClose={() => setEditingSocialLinkEntry(null)}
              socialLinkEntry={editingSocialLinkEntry}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onSocialLinkUpdated={(updatedList) => setSocialLinksDetails(updatedList)}
            />

            {/* Add Social Link Dialog */}
            <AddSocialLinkDialog
              open={addSocialLinkDialogOpen}
              onClose={() => setAddSocialLinkDialogOpen(false)}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onSocialLinkAdded={(updatedList) => setSocialLinksDetails(updatedList)}
            />

            {/* Delete Passkey Dialog */}
            <DeletePasskeyDialog
              open={deletePasskeyConfirmOpen}
              onClose={() => {
                setDeletePasskeyConfirmOpen(false);
                setPasskeyToDelete(null);
              }}
              passkeyEntry={passkeyToDelete}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onPasskeyDeleted={(updatedList) => setPasskeyDetails(updatedList)}
            />

            {/* Edit Passkey Dialog */}
            <EditPasskeyDialog
              open={!!editingPasskeyEntry}
              onClose={() => setEditingPasskeyEntry(null)}
              passkeyEntry={editingPasskeyEntry}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onPasskeyUpdated={(updatedList) => setPasskeyDetails(updatedList)}
            />

            {/* Add Passkey Dialog */}
            <AddPasskeyDialog
              open={addPasskeyDialogOpen}
              onClose={() => setAddPasskeyDialogOpen(false)}
              sessionId={sessionId}
              userId={user_id}
              onSuccess={(msg) => {
                setSnackbarMessage(msg);
                setSuccessSB(true);
              }}
              onError={(msg) => {
                setSnackbarMessage(msg);
                setErrorSB(true);
              }}
              onPasskeyAdded={(updatedList) => setPasskeyDetails(updatedList)}
            />

          </Grid>
          )}

          <Dialog open={imagePreview.open} onClose={closeImagePreview} maxWidth="sm" fullWidth>
            {imagePreview.title && <DialogTitle>{imagePreview.title}</DialogTitle>}
            <DialogContent dividers>
              {imagePreview.src ? (
                <Box
                  component="img"
                  src={imagePreview.src}
                  alt={imagePreview.title || "Document image"}
                  sx={{
                    width: "100%",
                    maxHeight: 480,
                    objectFit: "contain",
                    borderRadius: 1,
                  }}
                />
              ) : (
                <MDTypography variant="body2">Image not available.</MDTypography>
              )}
            </DialogContent>
            <DialogActions>
              <MDButton variant="outlined" color="info" size="small" onClick={closeImagePreview}>
                Close
              </MDButton>
            </DialogActions>
          </Dialog>

    
        </MDBox>
        <MDBox display="flex" justifyContent="center" mb={2} mr={2} mt={4}>
          <MDButton
            variant="gradient"
            color="error"
            onClick={handleCancel}
            startIcon={<Icon>arrow_back</Icon>}
          >
            Back
          </MDButton>
        </MDBox>
      </Header>

      {/* Edit Profile Dialog */}
      <EditProfileDialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        profile={profile}
        onSubmit={handleSubmitProfile}
        isSubmitting={isSubmitting}
        error={error}
        educationDetails={educationDetails}
      />

      {/* Success Snackbar */}
      <MDSnackbar
        color="success"
        icon="check"
        title="Success"
        content={snackbarMessage}
        dateTime="just now"
        open={successSB}
        onClose={() => setSuccessSB(false)}
        close={() => setSuccessSB(false)}
        bgWhite
      />

      {/* Error Snackbar */}
      <MDSnackbar
        color="error"
        icon="warning"
        title="Error"
        content={snackbarMessage}
        dateTime="just now"
        open={errorSB}
        onClose={() => setErrorSB(false)}
        close={() => setErrorSB(false)}
        bgWhite
      />
    </DashboardLayout>
  );
}

export default Overview;